import { useUserState } from '../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { maxUrlSearchLength } from '../../../../utils';
import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import React from 'react';
import { useGroupColumns } from './useGroupColumns';
import { mapGroupFilter, useGroupList } from './useGroupList';
import { useGroupsFilterConfig } from './useGroupsFilterConfig';
export function useGroupsTable({ useDataTableFunction = useDataTableUsingState, filterBased, rowSelectionEnabled, onRowClick, initialSelectedRowIds, showAccountsImportGroups, }) {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const { dataTableProps, filtersBarProps, appliedFilterData, clearActiveRow, reload, setSelectedRowIds, setActiveRowId } = useDataTableFunction({
        useDataProvider: (request) => useGroupList(request, { filterBased, showAccountsImportGroups }),
        onRowClick,
        rowSelectionEnabled,
        defaultSortColumnKey: 'name',
        maxUrlSearchLength,
        initialSelectedRowIds,
        defaultRowsPerPage: 100,
    });
    const columns = useGroupColumns();
    const filterConfig = useGroupsFilterConfig();
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { title: t('panels.groups.title'), columns: columns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' } }),
        filtersBarProps: filtersBarProps,
        appliedFilterData: appliedFilterData,
        appliedStorageFilters: mapGroupFilter(userState, appliedFilterData, filterBased),
        clearActiveRow: clearActiveRow,
        setActiveRowId: setActiveRowId,
        setSelectedRowIds: setSelectedRowIds,
        reload: reload,
    };
}
